import React from "react"
import { SystemValueInterface } from "../Api/System"

type SystemObject = {
    databaseVersion?: number
    systemBaseUrl?: string
    enableOnlineLesson?: boolean
}
const initialSystemObject: SystemObject = {
}

export function ObjectToSystemObject(obj: SystemValueInterface): SystemObject {
    return {
        databaseVersion: parseInt(obj.DATABASE_VERSION),
        systemBaseUrl: obj.SYSTEM_BASE_URL,
        enableOnlineLesson: obj.ENABLE_ONLINE_LESSON ? obj.ENABLE_ONLINE_LESSON==="ENABLE" : false,
    }
}

export const SystemObjectStore = React.createContext({} as {
    systemObject: SystemObject,
    setSystemObject: React.Dispatch<React.SetStateAction<SystemObject>>
})

export interface SystemObjectProviderProps {
    children: React.ReactNode
}
export function SystemObjectProvider(props: SystemObjectProviderProps) {
    const [systemObject, setSystemObject] = React.useState<SystemObject>(initialSystemObject)

    return (
        <SystemObjectStore.Provider value={{ systemObject, setSystemObject }}>
            {props.children}
        </SystemObjectStore.Provider>
    )
}